import './PartnersBlock.scss'

import {Picture} from '@codeurs/front'
import React from 'react'
import placeholder from '../../assets/images/partners.png'
import {ImageType, LinkType, WysiwygType} from '../../types'
import {Link} from '../../util/link'
import {style} from '../../util/style'
import {Theme} from '../../views/Theme'
import {Block} from './Blocks'

const styles = style('partnersblock', ['item'])

export type PartnersBlockType = {
	title: string
	text: WysiwygType
	inner_items: Array<PartnersBlockItemType>
}

type PartnersBlockItemType = {
	image: ImageType
	name: string
	link?: LinkType
}

export const PartnersBlock: React.FC<
	PartnersBlockType & {container?: boolean; sidebar?: boolean}
> = ({container, sidebar, title, text, inner_items: items}) => {
	if (!items || items.length === 0) return null

	return (
		<Block className={styles()} container={container} sidebar={sidebar}>
			{title && !sidebar && (
				<Theme.H4 className={styles('title')}>{title}</Theme.H4>
			)}
			{title && sidebar && (
				<Theme.H5 className={styles('title')}>{title}</Theme.H5>
			)}
			{text && <Theme.Wysiwyg className={styles('text')}>{text}</Theme.Wysiwyg>}
			<div className={styles('items')}>
				{items.map((item, i) => (
					<div key={i} className={styles('items-item')}>
						<PartnersBlockItem {...item} />
					</div>
				))}
			</div>
		</Block>
	)
}

export const PartnersBlockItem: React.FC<PartnersBlockItemType> = ({
	image,
	name,
	link
}) => {
	return (
		<div className={styles.item()}>
			<Link to={link?.url} className={styles.item('image')}>
				<Picture {...(image || placeholder)} alt={image?.alt || name} />
			</Link>
			{name && <p className={styles.item('name')}>{name}</p>}
			{link && (
				<Theme.Link to={link.url} className={styles.item('link')}>
					{link.description || link.title}
				</Theme.Link>
			)}
		</div>
	)
}
